import {DialogDismiss, DialogHeading, DialogProvider} from '@/components/ui/dialog-atoms/DialogAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {AgendaEditGenericEventFormProvider} from '@/features/agenda/components/agenda-event-form/agenda-edit-generic-event-form-provider/AgendaEditGenericEventFormProvider'
import {AgendaEventFormGenericFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-generic-fields/AgendaEventFormGenericFields'
import {
    StyledEventFormDialog,
    StyledEventFormDialogBody,
    StyledEventFormDialogHeader
} from '@/features/agenda/components/edit-event-form-dialog/style'
import {EditGenericEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useDialogStore} from '@ariakit/react'
import {EditGenericEventFormDialogFooter} from './EditGenericEventFormDialogFooter'

interface EditGenericEventFormDialogProps {
    defaultValues: EditGenericEventFormValidationSchema
    isOpen: boolean
    setIsOpen: (open: boolean) => void
}

export const EditGenericEventFormDialog = ({defaultValues, isOpen, setIsOpen}: EditGenericEventFormDialogProps) => {
    const dialogStore = useDialogStore({
        open: isOpen,
        setOpen: setIsOpen,
        defaultOpen: true
    })

    return (
        <DialogProvider store={dialogStore}>
            <StyledEventFormDialog width="680px" overflowY="unset" open={isOpen}>
                <EditGenericEventFormDialogContent defaultValues={defaultValues} />
            </StyledEventFormDialog>
        </DialogProvider>
    )
}

const EditGenericEventFormDialogContent = ({defaultValues}: {defaultValues: EditGenericEventFormValidationSchema}) => {
    const {t} = useTranslation()
    return (
        <>
            <StyledEventFormDialogHeader>
                <DialogHeading>{t('agenda:edit_event')}</DialogHeading>
                <DialogDismiss />
            </StyledEventFormDialogHeader>
            <AgendaEditGenericEventFormProvider defaultValues={defaultValues}>
                <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                    <StyledEventFormDialogBody>
                        <AgendaEventFormGenericFields />
                    </StyledEventFormDialogBody>
                </ScrollArea>
                <EditGenericEventFormDialogFooter />
            </AgendaEditGenericEventFormProvider>
        </>
    )
}
